import React from "react";
import { Row, Col, Card, CardBody } from "reactstrap";

interface ManualEntrySummaryCardsProps {
  totalPeriods: number;
  totalTimePoints: number;
  deviationsFound: number;
}

const ManualEntrySummaryCards: React.FC<ManualEntrySummaryCardsProps> = ({
  totalPeriods,
  totalTimePoints,
  deviationsFound,
}) => {
  return (
    <Row className="mb-4 g-3">
      <Col md={4}>
        <Card className="shadow-sm border mb-0 h-100 rounded-3">
          <CardBody className="d-flex align-items-center gap-3 p-3">
            <div className="avatar-sm flex-shrink-0">
              <span className="avatar-title bg-primary-subtle text-primary rounded-circle fs-3">
                <i className="ri-calendar-event-line"></i>
              </span>
            </div>
            <div>
              <h4 className="mb-1 text-dark fw-bold">{totalPeriods}</h4>
              <p className="text-muted mb-0 fs-13">Total Periods</p>
            </div>
          </CardBody>
        </Card>
      </Col>
      <Col md={4}>
        <Card className="shadow-sm border mb-0 h-100 rounded-3">
          <CardBody className="d-flex align-items-center gap-3 p-3">
            <div className="avatar-title-wrap avatar-sm flex-shrink-0">
              <span className="avatar-title bg-success-subtle text-success rounded-circle fs-3">
                <i className="ri-time-line"></i>
              </span>
            </div>
            <div>
              <h4 className="mb-1 text-dark fw-bold">{totalTimePoints}</h4>
              <p className="text-muted mb-0 fs-13">Total Time Points</p>
            </div>
          </CardBody>
        </Card>
      </Col>
      <Col md={4}>
        <Card className="shadow-sm border mb-0 h-100 rounded-3">
          <CardBody className="d-flex align-items-center gap-3 p-3">
            <div className="avatar-sm flex-shrink-0">
              <span className="avatar-title bg-warning-subtle text-warning rounded-circle fs-3">
                <i className="ri-alert-line"></i>
              </span>
            </div>
            <div>
              <h4 className="mb-1 text-dark fw-bold">{deviationsFound}</h4>
              <p className="text-muted mb-0 fs-13">Deviations Found</p>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default React.memo(ManualEntrySummaryCards);
